import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-divider',
    templateUrl: './block-divider.component.html',
})

export class BlockDividerComponent extends BlockAbstractComponent implements OnInit {

}
